class FontPreview extends HTMLElement {
  constructor() {
    super();
    this.fontSelector = this.querySelector("#font-selector");
    this.previewInput = this.querySelector("#PreviewTextInput");
    this.previewInput2 = this.querySelector("#PreviewTextInput2");
    this.previewOutput = this.querySelector("#PreviewTextOutput");
    this.previewOutput2 = this.querySelector(
      "#PreviewTextOutput2"
    );
    this.fontSelector.addEventListener(
      "change",
      this.handleFontChange.bind(this)
    );
    this.previewInput.addEventListener(
      "input",
      this.handleInputChange.bind(this)
    );
    this.previewInput2.addEventListener(
      "input",
      this.handleInputChange2.bind(this)
    );
  }

  handleFontChange() {
    this.previewOutput.className = '';
    this.previewOutput2.className = '';
    this.previewOutput.classList.add(this.fontSelector.value)
    this.previewOutput2.classList.add(this.fontSelector.value)
  }
  handleInputChange() {
    this.previewOutput.textContent = this.previewInput.value;
  }
  handleInputChange2() {
    this.previewOutput2.textContent = this.previewInput2.value;
  }
}

customElements.define("font-preview", FontPreview);
